import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import actionTypes2 from 'store/table2/actionTypes2';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import { setSituation2 as setSituationAction2 } from '../actions';

export function* setSituationGen(payload) {
  const {
    ts, isTrial, selectedBB, gameTable, isBBchanged, isGameTableChanged, ggps,
  } = payload.payload;

  const ggpsIsMtt = ggps === 'mtt';
  const ggpsIsHu = ggps === 'hu';

  const defineTs = () => {
    if (ggpsIsMtt) {
      if (isGameTableChanged) {
        return 'mttpot';
      }
      return ts;
    }

    if (ggpsIsHu) {
      return 'hu';
    }

    if (isGameTableChanged) {
      return 'low';
    }

    return ts;
  };

  try {
    const res = yield call(api, {
      method: 'post',
      url: sessionStorage.getItem('isPlo5') === 'true' ? URL.PLO5SITUATION : URL.SITUATION,
      data: {
        ts: defineTs(),
        bb: isBBchanged ? selectedBB : '100',
        game: gameTable,
        gg: ggps === 'gg',
      },
    });
    yield put(setSituationAction2.success({
      situation: res.data,
      ts,
      selectedBB,
      isTrial,
      isBBchanged,
      isGameTableChanged,
      gameTable,
      ggps,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(setSituationAction2.error(e.response));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes2.SET_SITUATION_2, setSituationGen);
}
